import { render, staticRenderFns } from "./RecordPagination.vue?vue&type=template&id=3a3d896e&scoped=true&"
import script from "./RecordPagination.vue?vue&type=script&lang=js&"
export * from "./RecordPagination.vue?vue&type=script&lang=js&"
import style0 from "./RecordPagination.vue?vue&type=style&index=0&id=3a3d896e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3d896e",
  null
  
)

export default component.exports